function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#63be6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.506,
  stopColor: "#5bbc6a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4ab96a"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  y1: 0.5,
  x2: 0.999,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ec6f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#45afe3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#faa51a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.387,
  stopColor: "#fab716"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.741,
  stopColor: "#fac412"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fac80f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ec3b50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e7515b"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "google-play-store",
  transform: "translate(0 0.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M19.982,11.682,1.145.106A.713.713,0,0,0,.382.114.823.823,0,0,0,0,.82S.008,1.887.015,3.644L13.736,18.4Z",
  transform: "translate(0 0)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M.2,44.4c.017,4.488.07,15.382.093,20.806l10.36-10.36Z",
  transform: "translate(-0.188 -41.82)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_170",
  "data-name": "Path 170",
  d: "M192.77,146.991l-8.209-4.691-4.761,4.755,5.372,5.372,7.6-4.43a.581.581,0,0,0,.291-.5A.589.589,0,0,0,192.77,146.991Z",
  transform: "translate(-169.347 -134.028)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_171",
  "data-name": "Path 171",
  d: "M1.7,234.554c.012,1.936.017,3.174.017,3.174a.567.567,0,0,0,.291.5.578.578,0,0,0,.581,0l14.842-8.656L12.06,224.2Z",
  transform: "translate(-1.601 -211.167)",
  fill: "url(#linear-gradient-4)"
}));

function SvgIcGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.719,
    height: 27.14,
    viewBox: "0 0 23.719 27.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGooglePlayStore);
export default ForwardRef;